import { React } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';

import Box from '@mui/material/Box';
// import Grid from '@mui/material/Grid';
// import Paper from '@mui/material/Paper';
import Image from 'material-ui-image';

import { METADATA } from '../../constants';
import successImage from '../../assets/images/checkout-success.webp';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    height: '100%',
    backgroundColor: '#FFF'
  },
  innerContentContainer: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%'
  },
  successCheckoutImage: {
    // padding: '50% 0px !important',
    position: 'relative !important',
    top: 'unset !important',
    left: 'unset !important',
    height: 'auto !important',
    width: 'auto !important',
    display: 'flex !important',
    justifyContent: 'center !important'
  },
  headerTitle: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px',
    fontWeight: 'bold',
    fontSize: '40px',

    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
      textAlign: 'center'
    }
  },
  subtitleContent: {
    fontSize: '1.5rem',

    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      padding: '0px 10%',
      textAlign: 'center'
    }
  },
  redirectAnchor: {
    width: '100%',
    fontSize: '1.5rem !important',
    display: 'flex',
    justifyContent: 'center',

    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important'
    }
  }
}));

export default function SuccessfulCheckout() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Helmet>
        <meta name="description" content={METADATA.SUCCESSFULCHECKOUT.description} />
        <title>{METADATA.SUCCESSFULCHECKOUT.title}</title>
      </Helmet>
      <Box sx={{ flexGrow: 1, height: '100%' }}>
        <div className={classes.innerContentContainer}>
          <div>
            <Image className={classes.successCheckoutImage} style={{ paddingTop: '0px', display: 'flex', justifyContent: 'center' }} cover='true' src={successImage} />
            <h1 className={classes.headerTitle}>Your Payment is Successful</h1>
            <p className={classes.subtitleContent}>Thank you for your payment. An automated payment receipt will be sent to your registered email.</p>
            <a className={classes.redirectAnchor} href="https://instoremusic.dk">Go to InstoreMusic</a>
          </div>
        </div>
      </Box>
    </div>
  )
}